import {RepositoryFactory} from "../../scripts/RepositoryFactory";

const SitesRepository = RepositoryFactory.get('sites');

// initial state
// shape: [{ id, quantity }]
const state = {
    sites: [],
    categories: [],
    categoriesLoading:false
};

// getters
const getters = {};

// actions
const actions = {
    async fetchAll({commit}) {
        const {data} = await SitesRepository.get();
        commit('setSites', {sites: data});
    },
    async fetchAllAdServer({commit}) {
        const {data} = await SitesRepository.getAdServerSites();
        commit('setSites', {sites: data});
    }
};

// mutations
const mutations = {
    setSites(state, {sites}) {
        state.sites = sites.sort(function (a, b) {
            let textA = a.name.toUpperCase();
            let textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
    },
    async setCategories(state, {parentId}) {
        state.categoriesLoading = true;
        state.categories = [];
        let categories = await SitesRepository.getSecondLevelAdServerSites(parentId);
        state.categories = categories.data;
        state.categoriesLoading = false;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}